import React from 'react';
import { Box, Typography } from '@mui/material';

const steps = [
  {
    number: 1,
    text: "Completează formularul și revenim către tine."
  },
  {
    number: 2,
    text: "Discutăm obiectivele tale financiare."
  },
  {
    number: 3,
    text: "Îți începi călătoria spre investiții profitabile."
  }
];

const ProcessSection = () => {
  return (
    <Box
      sx={{
        backgroundColor: '#fff',
        py: { xs: 2, xxl: 6 },
        px: 2,
        textAlign: 'center'
      }}
    >
      <Box
          sx={{
              width: { xs: "100%", xxl: "70%" },
              margin: "0 auto"
          }}
      >
        <Typography
          variant="h2"
          sx={{
            fontWeight: 'bold',
            fontSize: { xs: "20px", xxl: "36px" },
            color: '#002077',
            mb: 4
          }}
        >
          Cum funcționează procesul
        </Typography>

        <Box
          sx={{
            maxWidth: 600,
            mx: 'auto',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 4
          }}
        >
          {steps.map((step, index) => (
            <Box
              key={index}
              sx={{
                display: 'flex',
                alignItems: 'center',
                textAlign: 'center'
              }}
            >
              <Typography
                variant="h2"
                sx={{
                  fontWeight: 'bold',
                  color: '#20defa',
                  minWidth: 40
                }}
              >
                {step.number}
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  color: '#000',
                  fontSize: { xs: "14px", xxl: "21px" }, 
                  ml: 2
                }}
              >
                {step.text}
              </Typography>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default ProcessSection;